import React, { useState } from "react";

import styles from "./PasswordInput.module.scss";

const PasswordInput = ({
  label = "",
  error = false,
  register = null,
  placeholder,
}) => {
  let [isVisible, setIsVisible] = useState(false);

  const toggle = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className={styles.password_input}>
      <label>{label}</label>
      <input
        {...register}
        type={isVisible ? "text" : "password"}
        placeholder={placeholder}
        style={{ borderColor: error ? "#f90500" : "#c4c4c4" }}
      />
      {isVisible ? (
        <i className="bi bi-eye" onClick={() => toggle()}></i>
      ) : (
        <i className="bi bi-eye-slash" onClick={() => toggle()}></i>
      )}
    </div>
  );
};

export default PasswordInput;
